// extracted by mini-css-extract-plugin
module.exports = {"separator":"Common_separator__1mYq_"};